/*global _ */
import ReservationMixin from '../../../../../components/_mixins/event-reservation'
import {alert} from '../../../../../lib/utils'

export default {
  name: 'timeslot',
  mixins: [ReservationMixin],
  props: {
    time: {default: null},
    disabled: {default: false},
  },
  computed: {
    item() {
      return this.retrievedTimeslots[this.time]
    },
    disableSelection() {
      return this.disabled || false
    },
    isVisible() {
      const item = this.item
      const quantity = item.maxParticipants
      const tracks = _.size(item.tracks)
      return quantity && tracks
    },
    selected: {
      get() {
        return this.item.selected
      },
      async set(selected) {
        if (selected) {
          await this.setHold()
        } else {
          this.unhold()
        }
      }
    }
  },
  methods: {
    setSelected({time}, key, value) {
      this.updateSelectedTimeslot({time, [key]: value})
    },
    setRetrieved({time}, key, value) {
      this.updateRetrievedTimeslot({time, [key]: value})
    },
    async unhold(slots, noAnimation) {
      slots = slots || [{time: this.time}]
      for(const slotIndex in slots) {
        const slot = slots[slotIndex]
        await this.unholdSlot({time: slot.time}, noAnimation)
      }
    },
    async setHold() {
      const item = this.item
      const {time, tracks, hold} = item

      // mark timeslot as selected
      this.selectTimeslot({time})
      this.startHoldAnimation(time)

      // unhold previously selected slots
      const slotsToUnhold = _.omitBy(this.selectedSlots || {}, (slot, slotTime) => {
        return slotTime === time
      })
      await this.unhold(slotsToUnhold, true)

      const participants = this.participants
      const duration = this.duration
      const payload = {
        ..._.pick(hold || {}, ['product_id', 'start_at']),
        participants,
        duration,
        tracks
      }
      const newHold = await this.holdSlot({time}, payload)
      if (!newHold) {
        this.deselectTimeslot({time})
      }
      this.endHoldAnimation(time)
    },
    async selection() {
      if (this.isAnyProcessing()) {
        alert('One of the slots is being processed.')
        return false
      }
      const item = this.item
      if (item.processing) {
        alert('This selected slot is being processed.')
        return false
      }
      this.selected = !this.selected
    }
  }
}
